/**
 * SIMODE API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserPublic { 
    RoleId: string;
    Name: string;
    Surname: string;
    Email: string;
    Id: string;
    CustomerId: string;
    LastLogin: string | null;
    LastPasswordChange: string;
    CreationDate: string;
}

